// extracted by mini-css-extract-plugin
export var actions = "_so-4";
export var item = "_so-1";
export var price = "_so-3";
export var quantity = "_so-2";
export var table = "_so-0";